module.exports = {
  common: {
    title: '理奥CRM',
    copyright: 'NeonCRM Copyright © 2018 Z2 Systems, Inc. All rights reserved.',
    language: '语言'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh-CN.js